import { PickupPanel } from '../components/pickup/PickupPanel'
import { Link } from 'react-router'
import { TrackingForm } from '../components/tracking/TrackingForm'
import { siteConfig } from '../config/site'
import {
  featuredServices,
  getPreferredServicePath,
  serviceCategories,
  servicePages,
} from '../data'

const galleryItems = [
  { title: 'Professional Packing', position: '12%' },
  { title: 'Shipping Supplies', position: '35%' },
  { title: 'Print Services', position: '72%' },
  { title: 'Business Services', position: '92%' },
]

export function HomePage() {
  return (
    <>
      <title>Pack Print Mail | Packing, Shipping & Printing | Waxahachie, TX</title>
      <meta
        name="description"
        content="Pack Print Mail provides packing, shipping, printing, mailbox, and business services in Waxahachie, Texas."
      />
      <link rel="canonical" href={siteConfig.siteUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteConfig.displayName} />
      <meta property="og:title" content="Pack Print Mail | Waxahachie, TX" />
      <meta
        property="og:description"
        content="Local packing, shipping, printing, mailbox, and business services in Waxahachie, Texas."
      />
      <meta property="og:url" content={siteConfig.siteUrl} />
      <section className="hero-section">
        <div className="home-stage inner-shell">
          <section className="feature-banner" aria-labelledby="feature-title">
          <img src="/images/store-services-hero.png" alt="Packing supplies, parcels, and printed materials at a neighborhood service counter" />
          <div className="feature-banner__shade" />
          <div className="feature-banner__copy">
            <h1 id="feature-title">Packing & Shipping Services</h1>
            <p>
              Safe, secure and reliable service for your packing, shipping, printing,
              and business needs.
            </p>
            <div>
              <Link className="legacy-button legacy-button--dark" to="/Pack-Ship/Packing/Professional-Packing">Learn More</Link>
              <Link className="legacy-button" to="/contact-us">Contact Us</Link>
            </div>
          </div>
          <div className="carousel-dots" aria-hidden="true">
            <span className="is-active" /><span /><span /><span /><span /><span />
          </div>
          </section>

          <PickupPanel />
        </div>
      </section>

      <section className="welcome-section">
        <div className="welcome-grid inner-shell">
          <article className="welcome-copy">
          <h2>Welcome To Pack Print Mail</h2>
          <h3>Fast, Professional Shipping Service</h3>
          <p>
            Pack Print Mail, located in Waxahachie, TX, is the go-to resource for packing,
            shipping, printing and business service needs of local residents and businesses.
            Our team focuses on saving you time by helping you find the right service in one
            convenient visit.
          </p>
          <p>
            We can help prepare and ship items near and far. In addition to packing and
            shipping, Pack Print Mail provides copy, print, mailbox, and document services.
          </p>
          <p>
            We are an independently owned and operated neighborhood business center committed
            to convenient, efficient, and friendly service.
          </p>
          </article>

          <section className="featured-panel" aria-labelledby="featured-title">
          <div className="legacy-section-heading">
            <h2 id="featured-title">Our Featured Products & Services...</h2>
            <Link to="/Store-Services">See All Services &gt;&gt;</Link>
          </div>
          <div className="featured-grid">
            {featuredServices.map((featured, index) => {
              const service = servicePages.find(({ id }) => id === featured.serviceId)
              const category = serviceCategories.find(({ id }) => id === service?.categoryId)
              if (!service || !category) return null

              return (
                <Link
                  className="featured-item"
                  to={getPreferredServicePath(
                    service.id,
                    `/services/${category.slug}/${service.slug}`,
                  )}
                  key={featured.serviceId}
                >
                  <span className={`featured-item__circle featured-item__circle--${(index % 3) + 1}`} aria-hidden="true">
                    {featured.title.split(' ').map((word) => word[0]).join('').slice(0, 3)}
                  </span>
                  <strong>{featured.title}</strong>
                </Link>
              )
            })}
          </div>
          </section>
        </div>
      </section>

      <section className="marketing-home inner-shell">
        <h2>More Than Printing — We Help Businesses Grow</h2>
        <p>Launch your brand with one local partner. Pack Print Mail can help with your website, domain, hosting, business email, SEO, social media, advertising, labels, packaging and printed marketing materials.</p>
        <Link className="service-button service-button--primary" to="/digital-marketing">Explore Marketing & Website Services</Link>
      </section>

      <section className="partner-section" aria-label="Carrier and industry partners">
        <div className="partner-strip inner-shell">
          <strong>Industry Partners</strong>
          <span>FedEx</span><span>USPS</span><span>DHL</span>
        </div>
      </section>

      <section className="photo-section">
        <div className="photo-band inner-shell" aria-labelledby="pictures-title">
          <h2 id="pictures-title">Services at a glance</h2>
          <div className="photo-grid">
            {galleryItems.map((item) => (
              <figure key={item.title}>
                <img src="/images/store-services-hero.png" alt="" style={{ objectPosition: item.position }} />
                <figcaption>{item.title}</figcaption>
              </figure>
            ))}
          </div>
          <div className="photo-dots" aria-hidden="true"><span /><span /><span /><span /><span /></div>
        </div>
      </section>

      <section className="lower-section">
        <div className="lower-grid inner-shell">
          <div className="tracking-panel">
          <div className="tab-strip"><strong>Package Tracking</strong><span>Who We Are</span><span>Our Location</span></div>
          <div className="tracking-panel__body">
            <div className="parcel-art" aria-hidden="true">▣</div>
            <div>
              <h2>Package Tracking</h2>
              <p>Enter your shipment tracking number to check its current status with the appropriate carrier.</p>
              <TrackingForm idPrefix="home-tracking" />
            </div>
          </div>
          </div>
          <aside className="contact-card">
          <h2>Visit Pack Print Mail</h2>
          <p>{siteConfig.address.formatted}</p>
          <a href={siteConfig.phoneHref}>{siteConfig.phone}</a>
          <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a>
          </aside>
        </div>
      </section>
    </>
  )
}
